// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconBowl = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path
      fillRule="evenodd"
      d="M22.818 6H1.182v1c0 4.755 3.068 8.794 7.332 10.244L7.636 19h8.728l-.878-1.756c4.264-1.45 7.332-5.489 7.332-10.244zM12 15.818A8.82 8.82 0 013.238 8h17.524A8.82 8.82 0 0112 15.818"
    />
  );
export default SvgIconBowl;
